/**
 * Bundled art for Oshar VR Real Estate — only assets from VR_Realestate folder.
 */
import heroWide from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_21 PM (1).png";
import mapTopDown from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_22 PM (2).png";
import palaceNight from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_22 PM (3).png";
import commerceMarket from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_22 PM (4).png";
import waterfrontVenice from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_23 PM (5).png";
import aerialEstateRing from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_23 PM (6).png";
import councilGuild from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_23 PM (7).png";
import arenaColiseum from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_24 PM (8).png";
import luxuryStorefront from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_24 PM (9).png";
import balconyCity from "../assets/img/treydora_redesign/VR_Realestate/ChatGPT Image May 3, 2026, 09_12_24 PM (10).png";
import master from "../assets/img/treydora_redesign/VR_Realestate/master.png";
import farmBioluminescent from "../assets/img/treydora_redesign/VR_Realestate/farm-bioluminescent-district.png";
import vendorStallStorefront from "../assets/img/treydora_redesign/VR_Realestate/vendor-stall-storefront.png";

export const VR_RE_IMAGES = {
  heroWide,
  mapTopDown,
  palaceNight,
  commerceMarket,
  waterfrontVenice,
  aerialEstateRing,
  councilGuild,
  arenaColiseum,
  luxuryStorefront,
  vendorStallStorefront,
  balconyCity,
  master,
  farmBioluminescent,
};

export function vrImage(key) {
  return VR_RE_IMAGES[key] || master;
}
